module.exports = __webpack_public_path__ + "media/images/xpass/brand_previews/stretchlab-57ca4e14f1ccd88447c907f28af5157a.jpg";